import { Dispatch, SetStateAction, createContext } from "react";
import { PostProcedureEval } from "../../models";

export interface ITissueProcessingContext {
    postProcedureEval: PostProcedureEval | undefined;
    setPostProcedureEval: Dispatch<SetStateAction<PostProcedureEval | undefined>>;
    isFetching: boolean;
    setIsFetching: Dispatch<SetStateAction<boolean>>;
    isSaving: boolean;
    setIsSaving: Dispatch<SetStateAction<boolean>>;
    isLocked: boolean;
    lockedByName: string;
    unlock: (tissueId: number | string) => Promise<void>;
    sign: (pin: string, files?: string[]) => Promise<PostProcedureEval | undefined>;
    unlockSigned: (pin: string) => Promise<PostProcedureEval | undefined>;
    isLockedByMe: boolean;
    isSigned: boolean;
    isDisabled: boolean;
}

const defaultValue: ITissueProcessingContext = {
    postProcedureEval: undefined,
    setPostProcedureEval: () => { },
    isFetching: false,
    setIsFetching: () => { },
    isSaving: false,
    setIsSaving: () => { },
    isLocked: false,
    lockedByName: "",
    unlock: async () => { },
    sign: async () => undefined,
    unlockSigned: async () => undefined,
    isLockedByMe: false,
    isSigned: false,
    isDisabled: false,
};

export const TissueProcessingContext = createContext<ITissueProcessingContext>(defaultValue);
TissueProcessingContext.displayName = "TissueProcessing";
